import { render, staticRenderFns } from "./HikCameraVideo.vue?vue&type=template&id=bdf3fb3a&"
import script from "./HikCameraVideo.vue?vue&type=script&lang=js&"
export * from "./HikCameraVideo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports